import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NbTabsetComponent } from "@nebular/theme";
import { ApiService } from "../services/api.service";
import { CrowdsaleHelperService } from "../services/crowdsale-helper.service";

@Component({
    selector: "ngx-info",
    templateUrl: "./info.component.html",
    styleUrls: ["./info.component.scss"],
})
export class InfoComponent implements OnInit {
    public selectedPage: string | null = "";

    constructor(
        private _route: ActivatedRoute,
        private _aS: ApiService,
        public crowdsaleHelperService: CrowdsaleHelperService
    ) {}

    ngOnInit(): void {
        this._route.fragment.subscribe((fragment) => {
            this.selectedPage = fragment;
        });
        this._route.params.subscribe((paramData) => {
            this._aS
                .getCrowdsaleData(paramData.contractAddress)
                .subscribe((data: any) => {
                    console.log(paramData);
                    this.crowdsaleHelperService.crowdsaleData$.next(data);
                });
        });
    }
}
